var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getAppName, resetOnlogout, setLocalStorageValue, getLocalStorageValue, objToFormData } from '../Utils/UtilityFunctions';
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import axios from 'axios';
import { API, RESTRICT_ROUTE } from './Constants';
var instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    timeout: 900 * 1000,
    withCredentials: true,
});
instance.interceptors.request.use(function (req) { return __awaiter(void 0, void 0, void 0, function () {
    var username;
    return __generator(this, function (_a) {
        req.headers['X-CSRFToken'] = getLocalStorageValue('csrfToken');
        username = getLocalStorageValue('email');
        if (username && getLocalStorageValue('csrfToken')) {
            if (!req.data) {
                req.data = {};
            }
            if (!req.data.username) {
                req.data.username = getLocalStorageValue('email');
            }
        }
        req.data.appName = getAppName(); // will add a util function to change the source/app name LATER
        // Only convert to FormData if the method is not GET
        if (req.method !== 'get') {
            req.data = objToFormData(req.data);
        }
        return [2 /*return*/, req];
    });
}); }, function (err) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, Promise.reject(err)];
}); }); });
instance.interceptors.response.use(function (resp) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, resp === null || resp === void 0 ? void 0 : resp.data];
}); }); }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var restrictFlag;
    return __generator(this, function (_a) {
        if (error.response.status === 403) {
            if (error.response.config.url === API.USER_PROFILE) {
                resetOnlogout(window.location.pathname + window.location.search, false, true);
            }
            else {
                resetOnlogout(window.location.pathname + window.location.search);
            }
        }
        if (error.response.status === 409) {
            restrictFlag = localStorage.getItem('restrictFlag');
            if (restrictFlag === 'true' && !window.location.href.includes(RESTRICT_ROUTE)) {
                window.location.href = RESTRICT_ROUTE;
            }
            else {
                localStorage.setItem('restrictFlag', 'true');
                if (!window.location.href.includes(RESTRICT_ROUTE)) {
                    window.location.href = RESTRICT_ROUTE;
                }
            }
        }
        if (error.response.status === 504
            && (error.response.config.url === API.GENERATE_EMAIL
                || error.response.config.url === API.COMPANY_CHATBOT
                || error.response.config.url === API.DOCUMENT_HUB_CHATBOT
                || error.response.config.url === API.BUYER_GROUP_CHATBOT)) {
            setLocalStorageValue('timeout', 'true');
            window.dispatchEvent(new Event('storage'));
        }
        return [2 /*return*/, Promise.reject(error.response.data)];
    });
}); });
export default instance;
